export default function RelativeContactSection({
  values,
  errors,
  handleChange,
  labelStyle,
  inputStyle,
}) {
  return (
    <div>
      <label
        className="m-1 mt-4"
        style={{
          ...labelStyle,
          fontSize: "clamp(0.9rem, 1.2vw, 1.1rem)",
          textAlign: "center",
          display: "block",
          width: "100%",
          textDecoration: "underline",
          textUnderlineOffset: "3px",
        }}
      >
        ບຸກຄົນທີ່ຕິດຕໍ່ໄດ້ໃນກໍລະນີສຸກເສີນ
      </label>
      <div className="grid-container">
        {/* ຊື່ ແລະ ນາມສະກຸນ */}
        <div>
          <label style={labelStyle}>
            ຊື່ ແລະ ນາມສະກຸນ
            {!values.relativeBy && (
              <span style={{ marginLeft: 4, color: "red" }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="relativeBy"
            value={values.relativeBy}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນຊື່ ແລະ ນາມສະກຸນ"
          />
          {errors.relativeBy && (
            <p className="error-text">{errors.relativeBy}</p>
          )}
        </div>

        {/* ສາຍພົວພັນ */}
        <div>
          <label style={labelStyle}>
            ສາຍພົວພັນ
            {!values.relationship && (
              <span style={{ marginLeft: 4, color: "red" }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="relationship"
            value={values.relationship}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນສາຍພົວພັນ"
          />
          {errors.relationship && (
            <p className="error-text">{errors.relationship}</p>
          )}
        </div>

        {/* ເບີໂທຕິດຕໍ່ */}
        <div>
          <label style={labelStyle}>
            ເບີໂທຕິດຕໍ່
            {!values.relativePhone && (
              <span style={{ marginLeft: 4, color: "red" }}>*</span>
            )}
          </label>
          <input
            type="tel"
            name="relativePhone"
            value={values.relativePhone}
            onChange={handleChange}
            style={inputStyle}
            placeholder="85620XXXXXXXX"
          />
          {errors.relativePhone && (
            <p className="error-text">{errors.relativePhone}</p>
          )}
        </div>

        {/* ທີ່ຢູ່ປັດຈຸບັນ */}
        <div>
          <label style={labelStyle}>
            ທີ່ຢູ່ປັດຈຸບັນ
            {!values.relativeVillage && (
              <span style={{ marginLeft: 4, color: "red" }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="relativeVillage"
            value={values.relativeVillage}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນບ້ານ"
          />
          {errors.relativeVillage && (
            <p className="error-text">{errors.relativeVillage}</p>
          )}
        </div>

        {/* ເມືອງ */}
        <div>
          <label style={labelStyle}>
            ເມືອງ
            {!values.relativeDistrict && (
              <span style={{ marginLeft: 4, color: "red" }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="relativeDistrict"
            value={values.relativeDistrict}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນເມືອງ"
          />
          {errors.relativeDistrict && (
            <p className="error-text">{errors.relativeDistrict}</p>
          )}
        </div>

        {/* ແຂວງ */}
        <div>
          <label style={labelStyle}>
            ແຂວງ
            {!values.relativeProvince && (
              <span style={{ marginLeft: 4, color: "red" }}>*</span>
            )}
          </label>
          <input
            type="text"
            name="relativeProvince"
            value={values.relativeProvince}
            onChange={handleChange}
            style={inputStyle}
            placeholder="ປ້ອນແຂວງ"
          />
          {errors.relativeProvince && (
            <p className="error-text">{errors.relativeProvince}</p>
          )}
        </div>
      </div>
    </div>
  );
}
